export default "__VITE_ASSET__C8YsAzD8__"